import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import {BusService} from "../../../../@core/@bus/bus.service";
import {isCodiceFiscale, isPhoneFormatEs, isPhoneFormatIt, isRiferimento} from "../../../../models/validation";
import {GenericRequest, GenericResponse} from "../../../../models/generic";
import {Backend} from "../../../../core/backend";

@Component({
  selector: 'app-public-chat-bot-ef',
  templateUrl: './chat-bot-ef.component.html',
  styleUrls: ['./chat-bot-ef.component.scss']
})
export class ChatBotEFComponent implements OnInit{
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  maximized: boolean = false;
  messages: any[] = [];
  response: boolean = false;
  responseFinal: boolean = false;
  close: boolean = false;
  selectedOption: boolean = false;
  labelAsistente: string = $localize`Asistente Virtual`;
  labelMinimizar: string = $localize`Minimizar`;
  labelMaximizar: string = $localize`Maximizar`;
  labelCerrar: string = $localize`Cerrar`;
  labelEscribir: string = $localize`Escribir un mensaje...`;

  labelSeleccioneUno: string = $localize`Scegline uno:`;
  textoCutomMensaje1: string = $localize`Hai ricevuto un SMS, Mail o telefonata e vuoi essere ricontattato?`;
  textoCutomMensaje2: string = $localize`Hai problemi nell’effettuare il pagamento?`;
  textoCutomMensaje3: string = $localize`Altro`;
  labelNo: string = $localize`NO`;
  labelSi: string = $localize`SÍ`;
  labelConfirmacion1: string = $localize`Grazie, abbiamo preso in carico la tua richiesta. Entro 48 ore verrai ricontattato dal nostro consulente`;
  labelConfirmacion2: string = $localize`Grazie, abbiamo preso in carico la tua richiesta. Entro 24 ore verrai ricontattato dal nostro consulente`;

  logoBilly: string = 'assets/img/europafactor/billy.png';
  consulta: string = '';
  opcion: string = '';
  opcionBoolean: string = '';
  opcionStep: number = 0;
  failCount: number = 0;
  referenciaErronea: string = '';

  constructor(private bus: BusService) {}

  ngOnInit(): void {
    this.maximized = true;
    this.loadMessages();
  }

  sendMessage(event: any): void {
    const files = !event.files ? [] : event.files.map((file: { src: string; type: string }) => {
      return {
        url: file.src,
        type: file.type,
        icon: 'file-text-outline',
      };
    });
    
    this.addMessageReply(event.message, files);
    const ok = this.sendConsulta(event);
    if (!ok) {
      this.addMessageReply($localize`Le informazioni non sono corrette, inseriscile correttamente`, []);
    } else {
      if (this.responseFinal) {
        this.createTask();
      } else {
        this.nextStep();
      }
    }
  }

  private sendConsulta(event: any): boolean {
    let ok = true;
    
    if (this.opcionStep == 0) {
      if (this.opcionBoolean == 'si') {
        if (!isRiferimento(event.message)) {
          ok = false;
        }
      } else {
        if (!isCodiceFiscale(event.message)) {
          ok = false;
        }
      }
    } else if (this.opcionStep == 1) {
      if (!event.message || event.message.trim().length < 2) {
        ok = false;
      }
    } else if (this.opcionStep == 2) {
      if (!isPhoneFormatIt(event.message) && !isPhoneFormatEs(event.message)) {
        ok = false;
      }
    }

    if (ok) {
      if (this.consulta) {
        this.consulta = this.consulta + '-' + event.message;
      } else {
        this.consulta = event.message;
      }
    } else {
      this.validarIntentos();
    }
    return ok;
  }

  private loadMessages(): void {
    let company: string = 'Europa Factor';
    if(this.bus.isColectivoAdvTrade()){
      company = 'Advancing Trade';
    }
    this.addMessageBilly($localize`Ciao sono Billy, assistente virtuale di ` + company + $localize` come posso esserti utile?`);
    setTimeout((): void => {
      this.messages.push({
        type: 'list',
        reply: false,
        date: new Date(),
        user: {
          name: 'Billy',
          avatar: this.logoBilly,
        },
      });
    }, 500);
    setTimeout((): void => {
      this.messages.push({
        type: 'link',
        reply: false,
        date: new Date(),
        user: {
          name: 'Billy',
          avatar: this.logoBilly,
        },
        customMessageData: {
          href: 'https://www.europafactor.it/wp-content/uploads/2025/09/Informativa-recupero-crediti-artt.-13-14-GDPR_V02-2025_18.09.2025.pdf',
          text: $localize`Qui puoi consultare la Politica di Privacy`,
        },
      });
    }, 500);

  }

  selectOption(option: any): void {
    let text = '';
    if (this.opcion == '' || option == this.opcion) {
      text = $localize`Hai a disposizione il numero di pratica?`;
      this.opcion = option;
      this.response = true;
      this.addMessageBilly(text);
      this.selectedOption = true;
      
      setTimeout((): void => {
        this.messages.push({
          type: 'list2',
          reply: false,
          date: new Date(),
          user: {
            name: 'Billy',
            avatar: this.logoBilly,
          },
        });
      }, 500);
    }
  }

  selectOptionBoolean(option: any): void {
    let text = '';
    if (option == 'si') {
      text = $localize`Inserire il numero di pratica`;
      this.responseFinal = true;
    } else {
      text = $localize`Inserire il codice fiscale`;
    }

    this.opcionBoolean = option;
    this.opcionStep = 0;
    this.consulta = '';
    this.addMessageBilly(text);
  }

  closeChat(): void {
    this.close = true;
    this.onClose.emit(true);
    window.location.reload();
  }

  onClickMax(): void {
    this.maximized = true;
  }
  onClickMin(): void {
    this.maximized = false;
  }

  createTask(): void {
    if (this.referenciaErronea != '') {
      this.consulta = this.consulta + '-' + this.referenciaErronea;
    }

    const request: GenericRequest = new GenericRequest();
    request.command = 'consulta_chat_europafactor';
    request.data = this.opcion + '/' + this.consulta;
    Backend.generic(request).then( (response: GenericResponse): void => {
      if (response.error == "") {
        if (response.data > '0') {
          this.addMessageBilly(this.opcion == '2' ? this.labelConfirmacion2 : this.labelConfirmacion1);
          this.bus.dom.toastSuccess($localize`Consultazione creata con successo`);
        } else {
          if (this.opcionBoolean == 'si') {
            // No se ha encontrado el expediente, se pide Codice Fiscale, Nome e cognome, Telefono
            this.referenciaErronea = this.consulta;
            this.opcionBoolean = '';
            this.responseFinal = false;
            this.selectOptionBoolean('no');
          }
        }
      } else {
        this.bus.dom.toastError('Impossibile creare la consultazione');
      }
    });
  }

  nextStep(): void {
    this.opcionStep++;
    let text = '';
    
    if (this.opcionStep == 1) {
      text = $localize`Inserire il nome e cognome`;
    }
    else if (this.opcionStep == 2) {
      text = $localize`Inserire il numero di cellulare`;
      this.responseFinal = true;
    }
    
    this.addMessageBilly(text);
  }


  addMessageBilly(text: string): void {
    this.messages.push({
      text: text,
      date: new Date(),
      reply: false,
      user: {
        name: 'Billy',
        avatar: this.logoBilly,
      },
    });
  }

  addMessageReply(text: string, files: any): void {
    this.messages.push({
      text: text,
      date: new Date(),
      files: files,
      type: files.length ? 'file' : 'text',
      reply: true,
      user: {
        name: '',
        avatar: 'https://i.gifer.com/no.gif',
      },
    });
  }

  validarIntentos(): void {
    this.failCount++;
    if (this.failCount >= 3) {
      setTimeout(() => {
        this.addMessageBilly($localize`Lei ha fallito 3 volte, riprovi più tardi.`);
        setTimeout(() => {
          this.closeChat();
        }, 1500);
      }, 300);
    }
  }
}
